<template>
    <div class="container mt-5 pt-5" style="width: 70%;">
        <div class="h1 text-center"><strong>訂單紀錄</strong></div>
        <br>
        <div id="" class="collapse show" aria-labelledby="headingOne">
            <table class="table">
                <thead>
                    <tr>
                        <th width="120px"></th>
                        <th width="45%"> 商品名稱</th>
                        <th class="text-center">數量</th>
                        <th class="text-center" width="25%">價錢</th>
                    </tr>
                </thead>
                <tbody v-for="item, index in userOrders.data" :key="index" @click="goToOrderInformation(item.uuid)">
                    <tr style="height: 30px;">
                        <p style="margin-left: 20px">{{ convertTimeFormat(item.created_at) }}</p>
                    </tr>
                    <tr v-for="item, index in item.items" :key="index" style="background-color: rgb(245, 245, 245);">
                        <td class="align-middle">
                            <div class="card p-1 card-bottom">
                                <img :src="`${base_url}/uploads/${item.image}`" alt="..." width="100px;">
                            </div>
                        </td>
                        <td class="align-middle">
                            {{ item.name }}
                        </td>
                        <td class="align-middle text-center">{{ item.quantity }}</td>
                        <td class="align-middle text-center">$ {{ item.price }}</td>
                    </tr>
                </tbody>
            </table>

            <div style="display: flex; justify-content: space-between;">
                <div>第 {{ userOrders.current_page }} 頁 / 共 {{ userOrders.last_page }} 頁</div>
                <div>顯示 {{ userOrders.to ?? 0 }} 筆 / 共 {{ userOrders.total }} 筆</div>
            </div>
            <div style="display: flex; justify-content: center;">
                <button class=" btn btn-sm btn-outline-secondary" v-show="userOrders.first_page_url"
                    v-on:click="getOrderItem(userOrders.first_page_url)">第 1 頁</button>
                <button class="btn btn-sm btn-outline-secondary" v-show="userOrders.prev_page_url"
                    v-on:click="getOrderItem(userOrders.prev_page_url)">上一頁</button>
                <button class="btn btn-sm btn-outline-secondary" v-show="userOrders.next_page_url"
                    v-on:click="getOrderItem(userOrders.next_page_url)">下一頁</button>
                <button class=" btn btn-sm btn-outline-secondary" v-show="userOrders.first_page_url"
                    v-on:click="getOrderItem(userOrders.last_page_url)">最後一頁</button>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
export default {
    props: {
        text: {
            default: 0,
        },
    },
    data() {
        return {
            base_url,
            userOrders: {},
            information: [],
            inforname: '',
            key: '',
        };
    },
    methods: {
        getuserorders: function () {
            axios
                .get(base_url + "/api/user/orders/item")
                .then((response) => {
                    console.log(response.data);
                    this.userOrders = response.data;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        getOrderItem: function (url) {
            axios.get(url)
                .then((response) => {
                    console.log(response.data)
                    this.userOrders = response.data
                }).catch(function (error) {
                    console.log(error);
                });
        },
        goToOrderInformation: function (orderUuid) {
            location.href = base_url + "/api/cmple/" + orderUuid;
        },
        convertTimeFormat: function (time) {
            let UTC_time = new Date(time);
            console.log(UTC_time);
            let local_time = new Date(UTC_time.setHours(UTC_time.getHours() + 8));
            let year = local_time.getFullYear();
            let month = local_time.getMonth() + 1;
            let date = local_time.getDate();
            return year + '-' +
                month.toString().padStart(2, '0') + '-' +
                date.toString().padStart(2, '0');
        }
    },
    created() {
        this.getuserorders();
    },
}
</script>

<style scoped>
.homebtn {
    border: solid;
    padding: 10px;
    display: unset;
}

.alert-success {
    background-color: #FFEEE8 !important;
    font-weight: bold;
    font-size: 18px;
    color: #666666;
}
</style>>
